@if (hasConstraints && type == "create") {
  <div style="padding-top: 0.5rem">
    <span
      >NOTE: The creation of this resource must meet certain
      <a fd-link href="#" (click)="onClickConstraints($event, rule)"
        >constraints</a
      >, which aren't validated while you fill out this form. If they aren't
      met, an error will occur when you create the resource.</span
    >
  </div>
}

@if (hasConstraints && type == "edit") {
  <div style="padding-top: 0.5rem">
    <span
      >NOTE: The update of this resource must meet certain
      <a fd-link href="#" (click)="onClickConstraints($event, rule)"
        >constraints</a
      >, which aren't validated while you fill out this form. If they aren't
      met, an error will occur when you save your changes.</span
    >
  </div>
}

@if (hasConstraints && type == "delete") {
  <div style="padding-top: 0.5rem">
    <span
      >NOTE: The deletion of this resource must meet certain
      <a fd-link href="#" (click)="onClickConstraints($event, rule)"
        >constraints</a
      >, which aren't validated while you delete this resource. If they aren't
      met, an error will occur when you try to delete the resource.</span
    >
  </div>
}

@if (hasMultipleConstraints && type == "create") {
  <div style="padding-top: 0.5rem">
    <span
      >NOTE: The creation of this resource must meet certain constraints, which
      aren't validated while you fill out this form. If they aren't met, an
      error will occur when you create the resource. To find out which
      constraints apply, open the Policies view in the parent resource.</span
    >
  </div>
}

@if (hasMultipleConstraints && type == "edit") {
  <div style="padding-top: 0.5rem">
    <span
      >NOTE: The update of this resource must meet certain constraints, which
      aren't validated while you fill out this form. If they aren't met, an
      error will occur when you save your changes. To find out which constraints
      apply, open the Policies view in the parent resource.</span
    >
  </div>
}

@if (hasMultipleConstraints && type == "delete") {
  <div style="padding-top: 0.5rem">
    <span
      >NOTE: The deletion of this resource must meet certain constraints, which
      aren't validated while you delete this resource. If they aren't met, an
      error will occur when you try to delete the resource. To find out which
      constraints apply, open the Policies view in this resource.</span
    >
  </div>
}
